export default (api) => {
    return {
        getGuide: (challenge_version_id, practice_identifier, options) => api.get(`challenge_versions/${challenge_version_id}/practices/${practice_identifier}/rubric`, options)
    }
}
